export interface LanguageType {
  id: string;
  name: string;
  url: string;
  username: string;
  password: string;
}

export const LanguageNameCode = [
  {
    "lang": "Albanian",
    "code": "AL"
  },
  {
    "lang": "Arabic",
    "code": "AR"
  },
  {
    "lang": "Armenian",
    "code": "AM"
  },
  {
    "lang": "Azerbaijani",
    "code": "AZ"
  },
  {
    "lang": "Belarusian",
    "code": "BY"
  },
  {
    "lang": "Bosnian",
    "code": "BA"
  },
  {
    "lang": "Bulgarian",
    "code": "BG"
  },
  {
    "lang": "Catalan",
    "code": "CA"
  },
  {
    "lang": "Croatian",
    "code": "HR"
  },
  {
    "lang": "Czech",
    "code": "CZ"
  },
  {
    "lang": "Danish",
    "code": "DK"
  },
  {
    "lang": "Dutch",
    "code": "NL"
  },
  {
    "lang": "English",
    "code": "GB"
  },
  {
    "lang": "Estonian",
    "code": "EE"
  },
  {
    "lang": "Finnish",
    "code": "FI"
  },
  {
    "lang": "French",
    "code": "FR"
  },
  {
    "lang": "Galician",
    "code": "GL"
  },
  {
    "lang": "German",
    "code": "DE"
  },
  {
    "lang": "Greek",
    "code": "GR"
  },
  {
    "lang": "Hungarian",
    "code": "HU"
  },
  {
    "lang": "Icelandic",
    "code": "IS"
  },
  {
    "lang": "Irish",
    "code": "IE"
  },
  {
    "lang": "Italian",
    "code": "IT"
  },
  {
    "lang": "Latvian",
    "code": "LV"
  },
  {
    "lang": "Lithuanian",
    "code": "LT"
  },
  {
    "lang": "Luxembourgish",
    "code": "LU"
  },
  {
    "lang": "Macedonian",
    "code": "MK"
  },
  {
    "lang": "Maltese",
    "code": "MT"
  },
  {
    "lang": "Norwegian",
    "code": "NO"
  },
  {
    "lang": "Polish",
    "code": "PL"
  },
  {
    "lang": "Portuguese",
    "code": "PT"
  },
  {
    "lang": "Romanian",
    "code": "RO"
  },
  {
    "lang": "Russian",
    "code": "RU"
  },
  {
    "lang": "Serbian",
    "code": "RS"
  },
  {
    "lang": "Slovak",
    "code": "SK"
  },
  {
    "lang": "Slovenian",
    "code": "SI"
  },
  {
    "lang": "Spanish",
    "code": "ES"
  },
  {
    "lang": "Swedish",
    "code": "SE"
  },
  {
    "lang": "Turkish",
    "code": "TR"
  },
  {
    "lang": "Ukrainian",
    "code": "UA"
  },
  {
    "lang": "Welsh",
    "code": "CY"
  }
]
